import { render, staticRenderFns } from "./IhbarnameAdresBilgileriList.vue?vue&type=template&id=601aec5c"
import script from "./IhbarnameAdresBilgileriList.vue?vue&type=script&lang=ts"
export * from "./IhbarnameAdresBilgileriList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports